<template>
  <div class="goods_detial_home">
    <normal-detail v-if="showNormalDetail"></normal-detail>
    <blind-box-detail v-if="showBlindBoxDetail"></blind-box-detail>
  </div>
</template>
<script>
import NormalDetail from 'components/goods/NormalDetail';
import BlindBoxDetail from 'components/goods/BlindBoxDetail';
import * as goodsApis from 'apis/goods';
import { getQueryParams } from 'utils';
import _ from 'lodash';

export default {
  components: {
    NormalDetail,
    BlindBoxDetail,
  },
  data() {
    const { id: goodsId } = getQueryParams();
    return {
      showNormalDetail: false,
      showBlindBoxDetail: false,
      goodsId: goodsId ? Number(goodsId) : 0,
    };
  },
  async created() {
    await this.fetchDetail();
  },
  methods: {
    async fetchDetail() {
      if (this.goodsId) {
        try {
          const data = await goodsApis.getGoodsViewType({ goodsId: this.goodsId });
          if (!_.isEmpty(data)) {
            const { is_blind_box } = data;
            if (is_blind_box) {
              this.showBlindBoxDetail = true;
            } else {
              this.showNormalDetail = true;
            }
          }
        } catch (error) {
          const { message } = error;
          this.$toast(`获取商品详情失败:${message}`);
          this.$router.go(-1);
        }
      } else {
        this.$toast('商品不存在');
        this.$router.go(-1);
      }
    },
  },
};
</script>
<style lang="scss">
.goods_detial_home {
  height: 100%;
  -webkit-overflow-scrolling: touch;
  overflow-y: auto;
}
</style>

